import { LOYALTY_ID, CROWNANDANCHORNUMBER } from '../constants';
import { getCookie } from '../../../lib/utilities/Cookies';

export const parseQualifiers = (query, sendLoyalty = false) => {
  const { qualifiers } = query || {};
  const loyaltyId = getCookie(LOYALTY_ID.cookie);
  const queryQualifiers = qualifiers ? `${qualifiers}|` : '';
  if (sendLoyalty && loyaltyId) {
    return `${queryQualifiers}${CROWNANDANCHORNUMBER}:${loyaltyId}`;
  }
  return qualifiers;
};
